import { analyticsUtils } from '../../../utils/analytics-utils';

interface UseStretchBannerGa {
  gaPosition: string;
  gaName: string;
  setIsSentViewToGA: (value: boolean) => void;
}

export function useStretchBannerGa({ gaPosition, gaName, setIsSentViewToGA }: UseStretchBannerGa) {
  const handleViewToGA = () => {
    analyticsUtils.sendEvent('GA:promoView', {
      elementType: 'banner',
      elementBlock: gaPosition,
      promotions: [
        {
          name: gaName,
          creative: 'monetization',
          position: 1,
        },
      ],
    });
    setIsSentViewToGA(true);
  };

  const handleClickToGA = () => {
    analyticsUtils.sendEvent('GA:promoClick', {
      elementType: 'banner',
      elementBlock: gaPosition,
      promotions: [
        {
          name: gaName,
          creative: 'monetization',
          position: 1,
        },
      ],
    });
  };

  const handleClickButtonToGA = () => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: gaPosition,
      elementName: gaName,
      elementText: 'bannerMonetizationClose',
    });
  };

  return { handleClickToGA, handleViewToGA, handleClickButtonToGA };
}
